import React, { memo } from 'react'

import CubeIcon from './Components/CubeIcon/CubeIcon'

// Figma's shared `empty-state-icon`: a gradient badge holding the cube glyph, centred
// in decorative rings that overflow the badge on every side. Purely decorative, so the
// whole thing is hidden from assistive tech and the surrounding copy carries the meaning.
function EmptyStateIllustration() {
  return (
    <span className="empty-state-illustration" aria-hidden="true">
      <span className="empty-state-illustration__rings" />
      <span className="empty-state-illustration__badge">
        <CubeIcon />
      </span>
    </span>
  )
}

export default memo(EmptyStateIllustration)
